export default {
  radii: [0, '0.125rem', '0.25rem', '0.5rem', '1rem', '2rem'],
  radiusPill: '999px',
}
